
    import { defineComponent } from 'vue';
    import { endpointHeaderComposition } from '../services';

    export default defineComponent({
        name: 'endpoint-header',
        props: {
            arrowNavPath: {
                type: String,
                default: ''
            }
        },
        setup() {
            return { ...endpointHeaderComposition() }
        },
    })
